import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import BookingSessionsRoutes from './Constants/routes'

const BookingSessions = () => {
  const match = useRouteMatch()
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {BookingSessionsRoutes.map(({ path, Component, id, exact }) => (
          <Route
            path={`${match.url}${path}`}
            component={Component}
            exact={exact}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/booking-session" />
      </Switch>
    </>
  );
}

export default BookingSessions